import { Dispatch, SetStateAction, useEffect, useState } from "react";
import FlexPassApi from "../../../../../api/flexpassApi";
import { ISO639Lang } from "../../../../../constans/languagesList";
import {
  FlexPassFilteres,
  FlexPassSubscription,
} from "../../../../../types/FlexPassTypes";
import {
  DiscountPromocode,
  NewDiscountPromocode,
} from "../../../../../types/Promocodes";
import { getTranslation } from "../../../../../utils/getTranslation";
import { flexPassTypeStrings } from "../../../../FlexPass/flexPassUtils";
import s from "./FlexPassPromocode.module.css";

type FlexPassPromocodeProps = {
  setPromocodeData: Dispatch<SetStateAction<NewDiscountPromocode>>;
  promocodePropsData?: DiscountPromocode;
};

const FlexPassPromocode = ({
  setPromocodeData,
  promocodePropsData,
}: FlexPassPromocodeProps) => {
  const token = localStorage.getItem("token");
  const [filters] = useState<FlexPassFilteres>({
    page: 1,
    limit: 1000,
    endDate: { from: new Date() },
  });
  const [flexPasses, setFlexPasses] = useState<FlexPassSubscription[]>([]);
  const [selectedFlexPasses, setSelectedFlexPasses] = useState<
    FlexPassSubscription[]
  >(
    promocodePropsData && promocodePropsData.subscriptions?.length
      ? promocodePropsData.subscriptions
      : []
  );
  const [hasMore, setHasMore] = useState(true);
  const [isLoader, setIsLoader] = useState(false);

  const getFlexPasses = async () => {
    if (!token) return;
    setIsLoader(true);
    const response = await FlexPassApi.getFilteredFlexPassSubscriptions(
      token,
      filters
    );
    setIsLoader(false);

    if (response.status && response.subscriptions) {
      const prevFlexpassesIds =
        promocodePropsData && promocodePropsData.subscriptions?.length
          ? promocodePropsData.subscriptions.map((item) => item._id)
          : [];
      const flexPasseesData = response.subscriptions
        .map((item) => {
          if (!prevFlexpassesIds.includes(item._id)) {
            return item;
          }
        })
        .filter((el) => el);
      setFlexPasses((prev) => [
        ...prev,
        ...(flexPasseesData as FlexPassSubscription[]),
      ]);
      setHasMore(response.subscriptions.length >= filters.limit!);
    }
  };

  useEffect(() => {
    getFlexPasses();
  }, []);

  const removePass = (id: string) => {
    const removed = selectedFlexPasses.find((s) => s._id === id);
    if (removed) {
      setSelectedFlexPasses(selectedFlexPasses.filter((s) => s._id !== id));
      setFlexPasses([removed, ...flexPasses]);
    }
  };

  const addPass = (pass: FlexPassSubscription) => {
    if (!selectedFlexPasses.find((s) => s._id === pass._id)) {
      setSelectedFlexPasses([...selectedFlexPasses, pass]);
      setFlexPasses(flexPasses.filter((s) => s._id !== pass._id));
    }
  };

  const selectAll = () => {
    setSelectedFlexPasses((prev) => [...prev, ...flexPasses]);
    setFlexPasses([]);
  };

  useEffect(() => {
    const flexPassesIds = selectedFlexPasses.map((item) => item._id);
    setPromocodeData((prev) => ({
      ...prev,
      subscriptions: flexPassesIds.length ? flexPassesIds : undefined,
    }));
  }, [selectedFlexPasses]);

  return (
    <div className={s.container}>
      <div className={s.selectedBlock}>
        <h3>Selected FlexPasses</h3>

        <div className={s.selectedList}>
          {selectedFlexPasses.map((pass) => (
            <div key={pass._id} className={s.selectedItem}>
              <span>{pass.title[0].text}</span>
              <button onClick={() => removePass(pass._id)}>Remove</button>
            </div>
          ))}
        </div>
      </div>

      {isLoader && flexPasses.length === 0 ? (
        <p>Loading...</p>
      ) : flexPasses.length ? (
        <div className={s.listBlock}>
          <div className={s.selectAllBtn} onClick={selectAll}>
            Select All
          </div>
          {flexPasses.map((pass) => (
            <div key={pass._id} className={s.listItem}>
              <div>{pass.title[0].text}</div>
              <div>
                {new Date(pass.startDate).toLocaleDateString()}
                {" - "}
                {new Date(pass.endDate).toLocaleDateString()}
              </div>
              <div>{ISO639Lang[pass.language]}</div>
              <div>{pass.mainSpecialization.specialization}</div>
              <div>{getTranslation(pass.level.title, "en")}</div>
              <div>{pass.cost / 100}$</div>
              <div>{flexPassTypeStrings[pass.type]}</div>

              <button className={s.addButton} onClick={() => addPass(pass)}>
                Add
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ textAlign: "center" }}>No FlexPasses found</p>
      )}

      {/* Show more button */}
      {hasMore && !isLoader && (
        <button className={s.showMore} onClick={() => getFlexPasses()}>
          Show more
        </button>
      )}
    </div>
  );
};

export default FlexPassPromocode;
